import React from 'react'
import { Link } from 'react-router-dom'
import classes from './notFound.module.css'
import { ENotFound, INotFound } from './types'

const NotFound: React.FC<INotFound> = ({ type = ENotFound.ROUTE }) => (
  <div className={classes.container}>
    {type === ENotFound.ROUTE ? (
      <>
        <h1>Oops! We couldn't find this page</h1>
        <Link to="/">BACK TO HOME</Link>
      </>
    ) : (
      <h1>Please contact backend team to create you user profile</h1>
    )}
  </div>
)

export default NotFound
